import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  DealerBaseIProps,
  DealerMainIProps,
  PassportIProps,
  UpdateBlockQualityIProps,
} from "../model/schema";

const dealerServiceMap = {
  getById: "/dealer/base",
  getDataMain: "/dealer/main",
  getPassportMainData: "/passport",
  updateBlockQuality: "/secret-shopper/update",
  dealerMetrics: "/dealer-metrics",
};

export class Dealer {
  static _routes = dealerServiceMap;
  static GET = {
    getById: (params: string): NetworkResponse<DealerBaseIProps> =>
      requestREST.get(`${dealerServiceMap.getById}?${params}`),
    dealerMetrics: (params: string): NetworkResponse<DealerBaseIProps> =>
      requestREST.get(`${dealerServiceMap.dealerMetrics}?${params}`),
    getDataMain: (params: string): NetworkResponse<DealerMainIProps> =>
      requestREST.get(`${dealerServiceMap.getDataMain}?${params}`),
    getPassportMainData: (id: string): NetworkResponse<PassportIProps> =>
      requestREST.get(`${dealerServiceMap.getPassportMainData}?dealerId=${id}`),
  };
  static POST = {
    update: (
      params: UpdateBlockQualityIProps
    ): NetworkResponse<PassportIProps> =>
      requestREST.post(`${dealerServiceMap.updateBlockQuality}`, params),
  };
}
